import { Message, MessageType } from '@tv3/store/message/message.model'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import * as R from 'ramda'
import * as lodash from 'lodash'
import { isSomething, isUUIDLose } from '@tokeet-frontend/tv3-platform'
import { upperFirst } from 'lodash'

export class MessageDetails {
  id: string
  from: string
  to: string
  cc: string
  bcc: string
  receivedOn: number
  subject: string

  status: string
  readAt: number
  editedAt: number
  unsentAt: number
  spamScore: number
  spamFlag: string

  constructor(message: Message, inquiry: Inquiry) {
    this.id = message.id
    this.from = message.from
    if (message.type === MessageType.Outbound) {
      // sentto carries the actual recipient (phone number for SMS/WhatsApp,
      // email otherwise); the guest's email is only a fallback for old
      // messages persisted without it.
      this.to = message.sentTo || R.pathOr('', ['guest', 'primaryEmail'], inquiry)
    } else {
      this.from = message.replyTo || message.from
      this.to = message.sentTo
    }

    this.cc = lodash.isString(message.cc) ? message.cc : (message.cc || []).join(', ')
    this.bcc = lodash.isString(message.bcc) ? message.bcc : (message.bcc || []).join(', ')
    this.receivedOn = message.receivedOn
    this.subject = message.subject

    this.status = isSomething(message.delivery_status)
      ? upperFirst(message.delivery_status)
      : isUUIDLose(message.id.replace('-tk2', ''))
      ? 'Delivered'
      : 'Delivering'
    this.readAt = message.readAt
    this.editedAt = message.editedAt
    this.unsentAt = message.unsentAt
    this.spamScore = lodash.get(message, 'spam_score.X-Mailgun-Sscore', 0)
    this.spamFlag = lodash.get(message, 'spam_score.X-Mailgun-Sflag', 'No')
  }
}
